module.exports = __webpack_public_path__ + "img/WXbarcode2.9fd00248.png";